/* ---------------------------------
CampaignConfigError
Fail-closed page for hard template invariant violations (spec §5.6 / DDD-01).
Does NOT render the donation form.
--------------------------------- */

const SUPPORT_HREF = 'mailto:assistenza@airc.it'
const DEFAULT_MESSAGE = 'Configurazione campagna incompleta, contatta AIRC'

export default function CampaignConfigError({ message = DEFAULT_MESSAGE }) {
  return (
    <section className={'Section campaign-config-error'}>
      <div className={'Section__wrapper'}>
        <h1 className={'campaign-config-error__title'}>
          Configurazione non disponibile
        </h1>
        <p className={'campaign-config-error__message'}>{message}</p>
        <a
          className={'campaign-config-error__cta'}
          href={SUPPORT_HREF}
        >
          Contatta l&apos;assistenza AIRC
        </a>
      </div>
    </section>
  )
}
